import * as React from 'react';
import { IconPlaceholderAgency16, IconPlaceholderAgent16, IconPlaceholderImage16, IconPlaceholderUser16, IconInfrastructureBank16, IconPlaceholderBuilder16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export function AvatarFallbackIcon(_ref) {
  let {
    type
  } = _ref;
  const Icon = getIconComponent(type);
  return /*#__PURE__*/_jsx(Icon, {
    color: "icon-primary-disabled",
    "data-type": type
  });
}
export function getIconComponent(type) {
  switch (type) {
    case 'user':
    case 'homeowner':
      return IconPlaceholderUser16;
    case 'agent':
      return IconPlaceholderAgent16;
    case 'builder':
      return IconPlaceholderBuilder16;
    case 'agency':
      return IconPlaceholderAgency16;
    case 'bank':
      return IconInfrastructureBank16;
    default:
      return IconPlaceholderImage16;
  }
}